import { render, staticRenderFns } from "./officersItem.vue?vue&type=template&id=5863065c"
import script from "./officersItem.vue?vue&type=script&lang=js"
export * from "./officersItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports